export const EASETECH = "easetech"
export const VULATEL = "vulatel"
export const WAYLEAVE = "wayleave"
export const AOI = "aoi"
export const squareSymbol = "²"
export const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000

type PlatformSettings = {
  generalBuffer: number
  utilityBuffer: number
  daysBeforeExpired: number
  noResponseLimit: number
  afrigisBuffer: number
  easetechSearchBuffer: number
  maxProjectLengthIncoming: number
  maxProjectLength: number
  maxProjectLengthReportMode: number
  maxProjectArea: number
  maxProjectAreaReportMode: number
  maxProjectAreaIncoming: number
  aoiProjectLimitsMultiplier: number
  quotationVat: number
  closeToExpireDays: number
  expiredIn: number
  aoiDistance: number
  approvalExpiredIn: number
}

export const PLATFORM_SETTINGS: PlatformSettings = {
  expiredIn: 6,
  generalBuffer: 30,
  utilityBuffer: 20,
  daysBeforeExpired: 30,
  noResponseLimit: 30,
  afrigisBuffer: 20,
  easetechSearchBuffer: 10,
  maxProjectLengthIncoming: 100,
  maxProjectLength: 20,
  maxProjectLengthReportMode: 20,
  maxProjectArea: 20,
  maxProjectAreaReportMode: 10,
  maxProjectAreaIncoming: 87,
  // AOIs cover wider areas than wayleave applications: their length/area limits are the application limits × this
  aoiProjectLimitsMultiplier: 3,
  quotationVat: 15,
  closeToExpireDays: 30,
  aoiDistance: 2,
  approvalExpiredIn: 6,
}

export const globalColors = {
  primaryOrange: "#FF6600FF",
  defaultPrimaryColor: "#0F2745",
  defaultDarkPrimaryColor: "#0B1C32",
  extraLightGray: "#e1e6f4",
  lightGray: "#ccd1e0",
  gray: "#a3a9b6",
  darkGray: "#7c808d",
  extraDarkGray: "#474852",
  green: "#7fbeb3",
  statsColor1: "#8FC2D5",
  statsColor2: "#9FBDC0",
  statsColor3: "#5B8EC9",
  statsColor4: "#5277AE",
} as const
export const geometryColors = {
  serviceArea: "#7d009b",
  project: "#ff0c0c",
  underground: "#000000",
  overhead: "#ff6711",
  mixed: "#E076C1",
}

export const levelItemsColors = {
  level01: "#FF7777",
  level02: "#8CC9E8",
  level03: "#6EE9D0",
  level04: "#ffb56b",
} as const

export const geometryTypeOptions: { label: string; value: EnumAreaType }[] = [
  {
    label: "Underground Services",
    value: "underground",
  },
  {
    label: "Overhead Services",
    value: "overhead",
  },
  {
    label: "Mixed Services",
    value: "mixed",
  },
]

export const notAllowedToApproveAppStatuses = [
  "created",
  "quote_issued",
  "proof_of_payment_required",
  "unpaid",
  "invoice_created",
  "confirmed",
  "payment_requested",
  "outstanding_documents",
  "ready_for_submitting",
  "in_review",
  "reviewed",
  "canceled",
  "in_construction",
  "closed",
  "archived",
]
